<template>
    <div class="md talk-list">
        <ul>
            <li
                class="circle-li more"
                v-if="showChannel.length > maxShow"
            >
                <div
                    class="circle"
                    title="更多"
                    @click.prevent.stop="toggle('more')"
                ></div>
                <transition name="animate">
                    <ul v-if="show" class="func">
                        <li class="list-li remove-all" @click="closeAll">
                            <div class="list">全部關閉</div>
                        </li>
                        <li
                            v-for="channel in showChannelByType.list"
                            class="list-li people"
                            :class="[channel.unread > 0? 'has-notification': '']"
                            :key="channel.cid"
                        >
                            <div class="list" @click.stop="talkActiveAndRemoveTooltip(channel)">{{ channel.name }}</div>
                            <div class="remove" @click.stop="talkBubbleClose(channel)"></div>
                        </li>
                    </ul>
                </transition>
            </li>
            <li
                v-for="channel in showChannelByType.circle"
                class="circle-li people"
                :class="[channel.unread > 0? 'has-notification': '']"
                :key="channel.cid"
            >
                <div
                    class="circle"
                    :style="'background-image: url('+ $talkTool.getAvatar(channel) +')'"
                    @mouseenter="showChannelMessage($event, channel)"
                    @click.stop="talkActiveAndRemoveTooltip(channel)"
                ></div>
                <div class="remove" @click="talkBubbleClose(channel)"></div>
            </li>
            <li
                v-if="!stickerUnInit"
                class="circle-li talk"
            >
                <div
                    :class="[showTalkList? 'is-active': '', length? 'has-notification': '']"
                    class="circle"
                    @mouseenter="pushToolTip({
                        type: 'toolTip',
                        event: $event,
                        content: {
                            html: $t('site.func.talk'),
                        },
                    })"
                    @click.stop="toggleTalk"
                >
                    <span v-if="length">{{ length }}</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    
    export default {
        data: function(){

            return {
                maxShow: 4,
                id: 'talk',
                show: false,
            }
        },
        computed: {
            ...mapState([
                'user',
                'talk',
                'talkUIList',
                'talkChannels',
                'stickerUnInit',
                'showTalkList',
            ]),
            showChannel: function(){
                let $talkUIList = this.talkUIList,
                    $talkChannels = this.talkChannels;

                let $result = []

                $talkUIList.forEach(cid => {
                    let $target = $talkChannels.find(channel => channel.cid === cid);

                    if($target) {
                        $result.push($target);
                    }
                });

                $result.sort((a, b) => { return a.lasttime > b.lasttime? 1: -1 });

                return $result;
            },
            showChannelByType: function(){
                let $showChannel = this.showChannel,
                    _length = $showChannel.length,
                    _max = this.maxShow;

                let $result = {
                        list: [],
                        circle: [],
                    }

                if( _length > _max ) {
                    let _num = _length - _max;

                    $showChannel.forEach((item, index) => {

                        if( index < _num ) {
                            $result.list.push(item);
                        }else {
                            $result.circle.push(item);
                        }
                    });
                }else {
                    $result.circle = $showChannel;
                }

                return $result;
            },
            length: function() {
                return this.talkChannels.filter(item => item.unread).length;
            },
        },
        methods: {
            ...mapMutations([
                'pushToolTip',
                'clearToolTip',
                'globalClickFuncQueuePush',
                'globalClickFuncQueueRun',
                'globalClickFuncQueueClear',
                'talkActive',
                'talkBubbleClose',
                'changeState',
                'talkCreate',
            ]),
            closeAll: function(){
                let $user = state.user,
                    _adscuno = $user.adscuno;
                
                this.changeState({
                    talkUIList: [],
                });

                VueCookie.delete(_adscuno +'_talkUIList');
            },
            showChannelMessage: function(evt, channel){
                
                this.pushToolTip({
                    type: 'toolTip',
                    sn: channel.cid,
                    event: evt,
                    content: {
                        html: channel.name,
                        width: 'auto',
                    },
                    pointerEvents: 'none'
                });
            },
            talkActiveAndRemoveTooltip: function(channel){
                this.talkActive(channel);
                this.clearToolTip(channel.cid);
                this.hide();
            },
            toggle: function(){
                this.globalClickFuncQueueRun(this.id);
                this.show = !this.show;
            },
            hide: function(){
                this.show = false;
            },
            toggleTalk: function(){

                if( this.talkChannels.length ) {

                    this.changeState({
                        showTalkList: !this.showTalkList,
                    });
                }else {
                    this.startTalk();
                }
            },
            startTalk: function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'ContactSales',
                        func: 'Info',
                    });

                this.$http.post(_url, {}).then(res => { //弄完所有設定後開始取資料
                    let _saleid = res.saleid;

                    if( this.$siteConfig.devEvent ) { //測試機就給我
                        _saleid = 'n000170609'
                    }
                    
                    this.talkOpen(_saleid);

                }).catch(error => {

                    this.catchError({
                        error: error,
                        callback: this.startTalk,
                    });
                });
            },
            talkOpen: async function(saleid){
                let _url = this.$siteConfig.talkAccountUrl,
                    $form = new URLSearchParams({
                        account: saleid,
                        accessToken: this.talk.accessToken,
                    });
                    
                try {
                    let $response = await this.$http.post(_url, $form),
                        $data = $response.data;
                   
                    if( $data.result === 'SUCCESS' ) {
                        this.talkCreate($data.data.aid); //創造一個聊天
                    }else {
                        console.error($data);
                    }

                }catch(error) {
                    console.log(error)
                }
            },
        },
        created: function(){

            this.globalClickFuncQueuePush({
                id: this.id,
                func: this.hide
            });
        },
        destroyed: function(){
            this.globalClickFuncQueueClear(this.id);
        },
    }
</script>

<style scoped lang="scss">

    .animate-enter-active {
        animation: animate-in .3s;
    }

    .animate-leave-active {
        animation: animate-out .2s;
    }

    @keyframes animate-in {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .md.talk-list {
        $size: 42px;

        position: fixed;
        right: $interval-m;
        bottom: $interval-m;
        z-index: 8;

        @include media('mobile') {
            bottom: $size + $interval-m + $interval-s;
        }

        ul {
            @extend %reset;

            &.func {
                @extend %drop;
                display: block;
                right: calc(100% + #{$interval-s});
                margin-top: 0;
                max-height: 230px;
                width: 200px;
                overflow: auto;
            }
        }

        .list-li {
            position: relative;

            &.remove-all {
                border-bottom: $border;
            }

            &.people {

                &.has-notification {
                    $type: map-get($colors, 'danger');
                    $text: map-get($type, 'text'); 

                    $z: 6px;

                    .list {
                        
                        &::before {
                            content: $content;
                            display: block;
                            transition: $transition;
                            content: $content;
                            position: absolute;
                            left: $interval-m;
                            top: $interval-m;
                            width: $z;
                            height: $z;
                            border-radius: $z;
                            background-color: $text;
                        }
                    }
                }
            }
            
            .list {
                @extend %ellipsis;
                display: block;
                padding: $interval-m $interval-l;
                border-radius: 0;
                white-space: nowrap;
                transition: $transition;
                line-height: 17px;
                cursor: pointer;

                &:hover {
                    background-color: $light-gray;
                }
            }

            > .remove {
                $d: 16px;

                transition: $transition;
                position: absolute;
                top: 0;
                right: $interval-xs;
                cursor: pointer;

                &::before {
                    @extend %font-pseudo;
                    display: block;
                    content: '\e5cd';
                }

                &:hover {
                    color: $gray;
                }
            }
        }

        .circle-li {
            position: relative;

            + .circle-li {
                margin-top: $interval-s;
            }

            &.people {

                &.has-notification {
                    $type: map-get($colors, 'danger');
                    $text: map-get($type, 'text');
                    $border: map-get($type, 'border');

                    .circle {
                        box-shadow: 0 0 0 $interval-xs $text;
                    }

                    .remove {
                        background-color: $text;

                        &:hover {
                            background-color: $border;
                        }
                    }
                }

                &:hover {

                    .remove {
                        display: block;
                    }
                }

                .circle {
                    background-size: cover;
                    background-position: center;
                }
            }

            &.talk {

                .circle {
                    background-color: $major-color;

                    &::before {
                        content: '\e0b7';
                    }

                    &.is-active {

                        &::before {
                            content: '\e0ca';
                        }
                    }
                }

                span {
                    @extend %notification-span;
                    font-size: $font-size-s;
                    top: -1 * $interval-s;
                    right: -1 * $interval-s;
                }
            }

            &.more, &.send {

                .circle {
                    transition: $transition;
                    background-color: $deep-gray;

                    &:hover {
                        background-color: $gray;
                    }
                }
            }

            &.more {

                /*ul*/.func {
                    top: 0;
                }

                .circle {

                    &::before {
                        content: '\e5d3';
                    }
                }
            }

            &.send {

                /*ul*/.func {
                    bottom: 0;
                }

                .circle {

                    &::before {
                        content: '\e0bf';
                    }
                }
            }

            .circle {
                display: block;
                cursor: pointer;
                text-align: center;
                border-radius: $size;
                box-shadow: $box-shadow;
                color: $white;
                font-size: $font-size-xxl;
                width: $size;
                height: $size;

                &::before {
                    @extend %font-pseudo;
                    line-height: $size;
                }
            }

            > .remove {
                $z: 16px;

                transition: $transition;
                content: $content;
                display: none;
                position: absolute;
                top: -3px;
                right: -3px;
                width: $z;
                height: $z;
                cursor: pointer;
                text-align: center;
                font-size: $font-size-xs;
                border-radius: $z;
                background-color: $deep-gray;
                box-shadow: $box-shadow;
                color: $white;

                &:hover {
                    background-color: $gray;
                    color: $deep;
                }

                &::before {
                    @extend %font-pseudo;
                    display: block;
                    line-height: $z;
                    content: '\e5cd';
                }
            }
        }
    }
</style>
